import { Injectable } from '@angular/core';
import  {FullStory} from '@fullstory/browser';
declare const FS: any;
@Injectable({
  providedIn: 'root'
})

export class FullstoryService {

  // constructor() {
  //   // Initialize FullStory with your organization ID
  //   FullStory.init({ orgId: 'YOUR_ORG_ID' });
  // }
  constructor() {
    if (typeof FS === 'undefined') {
      console.warn('FullStory is not loaded or initialized properly.');
    }
  }

  /**
   * Identify a user in FullStory
   * @param uid User ID
   * @param properties Additional user properties
   */


  /**
   * Set identity in FullStory
   * @param uid User ID
   * @param properties Additional user properties
   */
  setIdentity(uid: string, properties: { [key: string]: any }) {
    console.log(uid)
    console.log(typeof FS)

    if (typeof FS !== 'undefined') {
      FS('setIdentity', {
        uid,
        properties,
      });
    } else {
      console.warn('FullStory is not initialized.');
    }
  }
  // setUserVars(uid: string, properties: { [key: string]: any }){
  //   // Combine the user ID with additional properties
  //   const userVars = {
  //     uid,
  //     ...properties
  //   };

  //   // Set user variables in FullStory
    
  //   FullStory.setIdentity(userVars);
  // }

}
